module.exports = __webpack_public_path__ + "static/img/index_2.29f318a8.jpg";